import { FC, useState, useEffect } from "react";
import { useForm } from "../../app/useForm";
import { parseNumberOrZero } from "../../../helpers";

type InputAttrs = React.InputHTMLAttributes<HTMLInputElement> & {
  fieldType: string;
};

export const Input: FC<InputAttrs> = ({ fieldType, ...args }) => {
  const { value, name } = { ...args };
  const [newValue, setNewValue] = useState(value);
  const { handleFieldChange } = useForm();

  useEffect(() => {
    setNewValue(value);
  }, [value]);

  return (
    <input
      {...args}
      onChange={(e) => {
        let value;
        if (fieldType === "number") {
          value = parseNumberOrZero(e.target.value);
        } else if (fieldType === "integer") {
          value = Math.trunc(parseNumberOrZero(e.target.value));
        } else {
          value = e.target.value;
        }
        handleFieldChange(name, value);
        setNewValue(e.target.value);
      }}
      className="w-full rounded-md border border-stone-300 pl-3 text-stone-900 placeholder-stone-400 focus:border-stone-500 focus:ring-stone-500 dark:border-stone-900 dark:bg-stone-700 dark:text-stone-100 dark:placeholder-stone-400 sm:text-sm"
      value={newValue}
    />
  );
};
